import { generateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/featureToggle';
import { callApiGetForFeatureToggle } from 'utilities/apiCaller';
import API from 'constants/api';

export const fetchFeatureToggles = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_FEATURE_TOGGLES_DATA.PENDING });
        try {
            const res = await callApiGetForFeatureToggle(`${API.FeatureToggle.GetFeatureTogglesData}`);
            dispatch({ type: TYPES.FETCH_FEATURE_TOGGLES_DATA.FULFILLED, featureToggles: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_FEATURE_TOGGLES_DATA.REJECTED, errors });
        }
    }

};